import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FlexboxGrid,
  Form,
  Input,
  Message,
  Modal,
  Stack,
  Table,
  Tooltip,
  Whisper,
  toaster
} from 'rsuite';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
let catalogueCodeCounter = 1;
const { Column, HeaderCell, Cell } = Table;
const ModalEnquiry = ({ open, onClose, empid, byernm, emcomp, ememail }) => {
  const [productdata, setProductData] = useState([]);
  const [customMap, setCustomMap] = useState([]);
  useEffect(() => {
    if (empid) {
      fetchDataproduct();
    }
  }, []);
  const fetchDataproduct = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/buyqrenquiry-dets?populate=*&filters[enqcd][$eq]=${empid}`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/buyqrenquiry-dets?populate=*&filters[enqcd][$eq]=${empid}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          prdcd: item.attributes.prdcd,
          customcode: item.attributes.customcode,
          customimage: item.attributes.Custom_Img?.data?.attributes?.url,
          price: item.attributes.price,
          remark: item.attributes.remark,
        }));
        allData.push(...processedData);
      }
      const uniqueProductMap = new Map();
      allData.forEach(item => {
        if (!uniqueProductMap.has(item.prdcd)) {
          uniqueProductMap.set(item.prdcd, item);
        }
      });

      const uniqueProductData = Array.from(uniqueProductMap.values());

      setProductData(uniqueProductData.map(item => item.prdcd));
      setCustomMap(uniqueProductData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleGenerateCata = () => {
    if (data.length == 0) {
      toaster.push(
        <Message showIcon type="warning">
          At least 1 product needed to generate catalogue.
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      setOpen1(true);
    }
  };

  /////// Generate Catalogue ///////
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // console.log("loading");
  // console.log(isLoading);

  useEffect(() => {
    if (productdata) {
      fetchProducts();
    }
  }, [productdata]);
  const fetchProducts = async () => {
    try {
      setIsLoading(true); // Set loading to true before fetching
      // Create an array of query parameters for each matching ID
      if (productdata.length > 0) {
        const productIdsQueryParam = productdata
          .map(id => `filters[ProductCode][$in][]=${id}`)
          .join('&');
        // Construct the API URL by appending the query parameters
        const apiUrl = `${globalIP}/api/products?${productIdsQueryParam}&populate=*`;
        // Fetch data from the API
        const response = await fetch(apiUrl);
        const json = await response.json();

        setData(json.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setIsLoading(false); // Set loading to false after fetching (whether success or failure)
    }
  };

  const [catalogueMeta, setcatalogueMeta] = useState<MetaData>();
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${globalIP}/api/catalogues?populate=*`);
    const json = await response.json();
    setcatalogueMeta(json.meta);
  };

  const generateCatalogue = () => {
    const nextCode = catalogueMeta?.pagination?.total + 1;
    return `CATLG-${nextCode.toString().padStart(3, '0')}`;
  };

  const [open1, setOpen1] = useState(false);
  const handleClose1 = () => setOpen1(false);
  const [cata, setCata] = useState({
    catalogueName: '',
    BuyerCompany: emcomp,
    BuyerEmail: ememail,
    CatalogueCode: '',
    BuyerName: byernm,
    Status: 'Active',
    CreateBy: '',
    CatalogueProduct: [
      {
        CatalogProduct: '',
        CatalogCode: ''
      }
    ]
  });
  const handleInputChange = (inputName, event) => {
    let value;
    if (event && event.target) {
      value = event.target.value;
    } else {
      value = event;
    }
    setCata({ ...cata, [inputName]: value });
  };
  const datattt = () => {
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      submit(event);
    }
  };
  const [loadingCata, setLoadingCata] = useState(false);
  const url2 = `${globalIP}/api/catalogues`;
  const submit = e => {
    e.preventDefault();
    if (cata.catalogueName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Catalogue Name
        </Message>,
        { placement: 'topEnd' }
      );
    } else {
      setLoadingCata(true);
      const nextCatalogueCode = generateCatalogue();
      const formData = new FormData();
      const updatedCatalogue = {
        ...cata,
        CatalogueCode: nextCatalogueCode,
        CatalogueProduct: data.map(item => ({
          CatalogProduct: String(item.id),
          CatalogCode: nextCatalogueCode,
          catcd: String(item.attributes.CategoryName),
          prodtypecd: String(item.attributes.ProductTypeName),
          aliascd: String(item.attributes.ProductId),
          productname: String(item.attributes.ProductTypeName),
          description: String(item.attributes.Description),
          unit: String(item.attributes.SizeUnit),
          len: item.attributes.Length,
          wid: item.attributes.Width,
          thick: item.attributes.Height,
          finish: String(item.attributes.FinishName),
          color: String(item.attributes.ColorName),
          netwgt: item.attributes.NetWeight,
          grswgt: item.attributes.GrossWeight,
          saleprice: item.attributes.SellingPrice,
          currency: String(item.attributes.SellingPriceCurrency),
          remark: String(item.attributes.Product_Remark),
          shape: 'N/A',
          cbm: item.attributes.cbm,
          SizeRange: String(item.attributes.SizeRange)
        }))
      };
      formData.append('data', JSON.stringify(updatedCatalogue));
      fetch(url2, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
        })
        .catch(error => console.error(error));
      catalogueCodeCounter++;
      toaster.push(
        <Message showIcon type="success">
          Saved Successfully
        </Message>,
        { placement: 'topCenter' }
      );
      setLoadingCata(false);
      setOpen1(false);
      onClose();
    }
  };
  /////// Generate Catalogue ///////
  return (
    <>
      <Modal size="full" open={open} onClose={onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            height={420}
            data={data}
            rowHeight={60}
            rowKey="id"
            bordered
            cellBordered
            loading={isLoading}
          >
            <Column width={100} align="center">
              <HeaderCell>
                <b>Sr. No.</b>
              </HeaderCell>
              <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Category</b>
              </HeaderCell>
              <Cell dataKey={'attributes.CategoryName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Image</b>
              </HeaderCell>
              <Table.Cell>
                {rowData => {
                  // Define a function to show the enlarged image on hover
                  const renderTooltip = imageSrc => (
                    <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                      <img
                        src={imageSrc}
                        alt="Product Image"
                        style={{ width: 400, height: 'auto' }}
                      />
                    </Tooltip>
                  );
                  return (
                    <Whisper
                      trigger="hover"
                      placement="right"
                      speaker={renderTooltip(
                        `${globalIP}${rowData.attributes.CoverImage?.data?.attributes?.url}`
                      )}
                    >
                      <img
                        src={`${globalIP}${rowData.attributes.CoverImage?.data?.attributes?.url}`}
                        alt="Product Image"
                        style={{ width: 50, height: 50, marginTop: '-16px' }}
                      />
                    </Whisper>
                  );
                }}
              </Table.Cell>
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Alias Code</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductId'} />
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Product Name</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Finish</b>
              </HeaderCell>
              <Cell dataKey={'attributes.FinishName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Color</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ColorName'} />
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Custom Image</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  const imageUrl = custom?.customimage ? `${globalIP}${custom.customimage}` : null;

                  if (!imageUrl) return '-';

                  return (
                    <Whisper
                      trigger="hover"
                      placement="right"
                      speaker={
                        <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                          <img
                            src={imageUrl}
                            alt="Custom Image"
                            style={{ width: 400, height: 'auto' }}
                          />
                        </Tooltip>
                      }
                    >
                      <img
                        src={imageUrl}
                        alt="Custom Image"
                        style={{ width: 50, height: 50, marginTop: '-16px' }}
                      />
                    </Whisper>
                  );
                }}
              </Cell>
            </Column>

            <Column width={160} align="center">
              <HeaderCell>
                <b>Custom Code</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  return custom?.customcode || '-';
                }}
              </Cell>
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Price</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  return custom?.price || '-';
                }}
              </Cell>
            </Column>
            <Column width={160} align="center">
              <HeaderCell>
                <b>Remark</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const custom = customMap.find(
                    item => item.prdcd === rowData.attributes.ProductCode
                  );
                  return custom?.remark || '-';
                }}
              </Cell>
            </Column>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleGenerateCata}
            appearance="primary"
            color="cyan"
            style={{ marginTop: '20px', opacity: data.length == 0 ? '0.8' : '1' }}
          >
            Generate Catalogue
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="xs">
        <Modal.Header>
          <b>Please fill catalogue name.</b>
        </Modal.Header>
        <Modal.Body>
          <Form fluid>
            <Form.ControlLabel>
              <Stack>
                <p>Catalogue Name </p>
                <p style={{ color: 'red' }}>*</p>
              </Stack>
            </Form.ControlLabel>
            <Input
              id="catalogueName"
              name="catalogueName"
              value={cata && cata.catalogueName ? cata.catalogueName : ''}
              onChange={value => handleInputChange('catalogueName', value)}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Stack justifyContent="flex-end">
            <Button onClick={datattt} appearance="primary" color="cyan" loading={loadingCata}>
              Finish
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalEnquiry;
